// Единый формат российского номера телефона: +7 (999) 123-45-67

export const RU_PHONE_PLACEHOLDER = "+7 (___) ___-__-__";

export const extractPhoneDigits = (value) => {
  let digits = String(value || "").replace(/\D/g, "");
  if (digits.startsWith("8")) digits = "7" + digits.slice(1);
  if (digits.startsWith("9") && digits.length <= 10) digits = "7" + digits;
  if (!digits.startsWith("7")) digits = digits ? "7" + digits : "";
  return digits.slice(0, 11);
};

export const formatRuPhone = (value) => {
  const digits = extractPhoneDigits(value);
  if (!digits) return "";
  const rest = digits.slice(1);
  let out = "+7";
  if (rest.length > 0) out += ` (${rest.slice(0, 3)}`;
  if (rest.length >= 3) out += ")";
  if (rest.length > 3) out += ` ${rest.slice(3, 6)}`;
  if (rest.length > 6) out += `-${rest.slice(6, 8)}`;
  if (rest.length > 8) out += `-${rest.slice(8, 10)}`;
  return out;
};

export const isValidRuPhone = (value) => extractPhoneDigits(value).length === 11;
